export const MODE = {
    UPDATE: '2',
    INSERT: '1',
    DELETE: '3'
};

export const FAQ_CONSTANTS = {
    HELP_CENTER_TITLE: 'お客様画面ヘルプセンター'
};

export const mode = {
    U: 'Up',
    N: 'Normal'
};

export const password_input_rule =
    'パスワードルール：大文字、小文字、数字、記号　全てを含んだ10文字以上\n大文字：　A~Z\n小文字：　a~z\n数字　：　0~9\n記号　：　#、$、@';

export const NOTE_ADDRESS_1 = '※都道府県、市区町村、番地';
export const NOTE_ADDRESS_2 = '※建物名、部屋番号、その他';

export const CUS_ORDER_STATUS = {
    0: '下書き',
    1: '見積依頼中',
    2: '見積を確認する',
    3: '新規申込中',
    4: '変更申込中',
    5: 'キャンセル申込中',
    6: '調整中',
    7: '新規受諾',
    8: '変更受諾',
    9: 'キャンセル受諾',
    10: 'キャンセル受諾(請求発生)',
    11: '御断りさせていただきます',
    12: '完了'
};
export const MNG_ORDER_STATUS_1 = {
    1: '下書き',
    2: '見積未作成',
    3: '社内承認中',
    4: '見積済'
};
export const MNG_ORDER_STATUS_2 = {
    1: '新規申込',
    2: '変更申込',
    3: 'キャンセル申込',
    4: '調整中',
    5: '作成済',
    6: '変更済',
    7: 'キャンセル済',
    8: 'お客様都合キャンセル',
    9: 'ムーヴ都合キャンセル',
    10: '完了'
};
export const SYSTEM_COLORS = [
    {
        NAME: 'black',
        COLOR: '#000000'
    },
    {
        NAME: 'navy',
        COLOR: '#000080'
    },
    {
        NAME: 'darkblue',
        COLOR: '#00008b'
    },
    {
        NAME: 'mediumblue',
        COLOR: '#0000cd'
    },
    {
        NAME: 'blue',
        COLOR: '#0000ff'
    },
    {
        NAME: 'darkgreen',
        COLOR: '#006400'
    },
    {
        NAME: 'green',
        COLOR: '#008000'
    },
    {
        NAME: 'teal',
        COLOR: '#008080'
    },
    {
        NAME: 'darkcyan',
        COLOR: '#008b8b'
    },
    {
        NAME: 'deepskyblue',
        COLOR: '#00bfff'
    },
    {
        NAME: 'darkturquoise',
        COLOR: '#00ced1'
    },
    {
        NAME: 'mediumspringgreen',
        COLOR: '#00fa9a'
    },
    {
        NAME: 'lime',
        COLOR: '#00ff00'
    },
    {
        NAME: 'springgreen',
        COLOR: '#00ff7f'
    },
    {
        NAME: 'cyan',
        COLOR: '#00ffff'
    },
    {
        NAME: 'aqua',
        COLOR: '#00ffff'
    },
    {
        NAME: 'midnightblue',
        COLOR: '#191970'
    },
    {
        NAME: 'dodgerblue',
        COLOR: '#1e90ff'
    },
    {
        NAME: 'lightseagreen',
        COLOR: '#20b2aa'
    },
    {
        NAME: 'forestgreen',
        COLOR: '#228b22'
    },
    {
        NAME: 'seagreen',
        COLOR: '#2e8b57'
    },
    {
        NAME: 'darkslategray',
        COLOR: '#2f4f4f'
    },
    {
        NAME: 'limegreen',
        COLOR: '#32cd32'
    },
    {
        NAME: 'mediumseagreen',
        COLOR: '#3cb371'
    },
    {
        NAME: 'turquoise',
        COLOR: '#40e0d0'
    },
    {
        NAME: 'royalblue',
        // COLOR: '#4169e1'
        COLOR: '#6495ED'
    },
    {
        NAME: 'steelblue',
        COLOR: '#4682b4'
    },
    {
        NAME: 'darkslateblue',
        COLOR: '#483d8b'
    },
    {
        NAME: 'mediumturquoise',
        COLOR: '#48d1cc'
    },
    {
        NAME: 'indigo',
        COLOR: '#4b0082'
    },
    {
        NAME: 'darkolivegreen',
        COLOR: '#556b2f'
    },
    {
        NAME: 'cadetblue',
        COLOR: '#5f9ea0'
    },
    {
        NAME: 'cornflowerblue',
        COLOR: '#6495ed'
    },
    {
        NAME: 'mediumaquamarine',
        COLOR: '#66cdaa'
    },
    {
        NAME: 'dimgray',
        COLOR: '#696969'
    },
    {
        NAME: 'slateblue',
        COLOR: '#6a5acd'
    },
    {
        NAME: 'olivedrab',
        COLOR: '#6b8e23'
    },
    {
        NAME: 'slategray',
        COLOR: '#708090'
    },
    {
        NAME: 'lightslategray',
        COLOR: '#778899'
    },
    {
        NAME: 'mediumslateblue',
        COLOR: '#7b68ee'
    },
    {
        NAME: 'lawngreen',
        COLOR: '#7cfc00'
    },
    {
        NAME: 'chartreuse',
        COLOR: '#7fff00'
    },
    {
        NAME: 'aquamarine',
        COLOR: '#7fffd4'
    },
    {
        NAME: 'maroon',
        COLOR: '#800000'
    },
    {
        NAME: 'purple',
        COLOR: '#800080'
    },
    {
        NAME: 'olive',
        COLOR: '#808000'
    },
    {
        NAME: 'gray',
        COLOR: '#808080'
    },
    {
        NAME: 'skyblue',
        COLOR: '#87ceeb'
    },
    {
        NAME: 'lightskyblue',
        COLOR: '#87cefa'
    },
    {
        NAME: 'blueviolet',
        COLOR: '#8a2be2'
    },
    {
        NAME: 'darkred',
        COLOR: '#8b0000'
    },
    {
        NAME: 'darkmagenta',
        COLOR: '#8b008b'
    },
    {
        NAME: 'saddlebrown',
        COLOR: '#8b4513'
    },
    {
        NAME: 'darkseagreen',
        COLOR: '#8fbc8f'
    },
    {
        NAME: 'lightgreen',
        COLOR: '#90ee90'
    },
    {
        NAME: 'mediumpurple',
        COLOR: '#9370db'
    },
    {
        NAME: 'darkviolet',
        COLOR: '#9400d3'
    },
    {
        NAME: 'palegreen',
        COLOR: '#98fb98'
    },
    {
        NAME: 'darkorchid',
        COLOR: '#9932cc'
    },
    {
        NAME: 'yellowgreen',
        COLOR: '#9acd32'
    },
    {
        NAME: 'sienna',
        COLOR: '#a0522d'
    },
    {
        NAME: 'brown',
        COLOR: '#a52a2a'
    },
    {
        NAME: 'darkgray',
        COLOR: '#a9a9a9'
    },
    {
        NAME: 'lightblue',
        COLOR: '#add8e6'
    },
    {
        NAME: 'greenyellow',
        COLOR: '#adff2f'
    },
    {
        NAME: 'paleturquoise',
        COLOR: '#afeeee'
    },
    {
        NAME: 'lightsteelblue',
        COLOR: '#b0c4de'
    },
    {
        NAME: 'powderblue',
        COLOR: '#b0e0e6'
    },
    {
        NAME: 'firebrick',
        COLOR: '#b22222'
    },
    {
        NAME: 'darkgoldenrod',
        COLOR: '#b8860b'
    },
    {
        NAME: 'mediumorchid',
        COLOR: '#ba55d3'
    },
    {
        NAME: 'rosybrown',
        COLOR: '#bc8f8f'
    },
    {
        NAME: 'darkkhaki',
        COLOR: '#bdb76b'
    },
    {
        NAME: 'silver',
        COLOR: '#c0c0c0'
    },
    {
        NAME: 'mediumvioletred',
        COLOR: '#c71585'
    },
    {
        NAME: 'indianred',
        COLOR: '#cd5c5c'
    },
    {
        NAME: 'peru',
        COLOR: '#cd853f'
    },
    {
        NAME: 'chocolate',
        COLOR: '#d2691e'
    },
    {
        NAME: 'tan',
        COLOR: '#d2b48c'
    },
    {
        NAME: 'lightgrey',
        COLOR: '#d3d3d3'
    },
    {
        NAME: 'thistle',
        COLOR: '#d8bfd8'
    },
    {
        NAME: 'orchid',
        COLOR: '#da70d6'
    },
    {
        NAME: 'goldenrod',
        COLOR: '#daa520'
    },
    {
        NAME: 'palevioletred',
        COLOR: '#db7093'
    },
    {
        NAME: 'crimson',
        COLOR: '#dc143c'
    },
    {
        NAME: 'gainsboro',
        COLOR: '#dcdcdc'
    },
    {
        NAME: 'plum',
        COLOR: '#dda0dd'
    },
    {
        NAME: 'burlywood',
        COLOR: '#deb887'
    },
    {
        NAME: 'lightcyan',
        COLOR: '#e0ffff'
    },
    {
        NAME: 'lavender',
        COLOR: '#e6e6fa'
    },
    {
        NAME: 'darksalmon',
        COLOR: '#e9967a'
    },
    {
        NAME: 'violet',
        COLOR: '#ee82ee'
    },
    {
        NAME: 'palegoldenrod',
        COLOR: '#eee8aa'
    },
    {
        NAME: 'lightcoral',
        COLOR: '#f08080'
    },
    {
        NAME: 'khaki',
        COLOR: '#f0e68c'
    },
    {
        NAME: 'aliceblue',
        COLOR: '#f0f8ff'
    },
    {
        NAME: 'honeydew',
        COLOR: '#f0fff0'
    },
    {
        NAME: 'azure',
        COLOR: '#f0ffff'
    },
    {
        NAME: 'sandybrown',
        COLOR: '#f4a460'
    },
    {
        NAME: 'wheat',
        COLOR: '#f5deb3'
    },
    {
        NAME: 'beige',
        COLOR: '#f5f5dc'
    },
    {
        NAME: 'whitesmoke',
        COLOR: '#f5f5f5'
    },
    {
        NAME: 'mintcream',
        COLOR: '#f5fffa'
    },
    {
        NAME: 'ghostwhite',
        COLOR: '#f8f8ff'
    },
    {
        NAME: 'salmon',
        COLOR: '#fa8072'
    },
    {
        NAME: 'antiquewhite',
        COLOR: '#faebd7'
    },
    {
        NAME: 'linen',
        COLOR: '#faf0e6'
    },
    {
        NAME: 'lightgoldenrodyellow',
        COLOR: '#fafad2'
    },
    {
        NAME: 'oldlace',
        COLOR: '#fdf5e6'
    },
    {
        NAME: 'red',
        COLOR: '#ff0000'
    },
    {
        NAME: 'fuchsia',
        COLOR: '#ff00ff'
    },
    {
        NAME: 'magenta',
        COLOR: '#ff00ff'
    },
    {
        NAME: 'deeppink',
        COLOR: '#ff1493'
    },
    {
        NAME: 'orangered',
        COLOR: '#ff4500'
    },
    {
        NAME: 'tomato',
        COLOR: '#ff6347'
    },
    {
        NAME: 'hotpink',
        COLOR: '#ff69b4'
    },
    {
        NAME: 'coral',
        COLOR: '#ff7f50'
    },
    {
        NAME: 'darkorange',
        COLOR: '#ff8c00'
    },
    {
        NAME: 'lightsalmon',
        COLOR: '#ffa07a'
    },
    {
        NAME: 'orange',
        // COLOR: '#ffa500'
        COLOR: '#EDA618'
    },
    {
        NAME: 'lightpink',
        COLOR: '#ffb6c1'
    },
    {
        NAME: 'pink',
        COLOR: '#ffc0cb'
    },
    {
        NAME: 'gold',
        COLOR: '#ffd700'
    },
    {
        NAME: 'peachpuff',
        COLOR: '#ffdab9'
    },
    {
        NAME: 'navajowhite',
        COLOR: '#ffdead'
    },
    {
        NAME: 'moccasin',
        COLOR: '#ffe4b5'
    },
    {
        NAME: 'bisque',
        COLOR: '#ffe4c4'
    },
    {
        NAME: 'mistyrose',
        COLOR: '#ffe4e1'
    },
    {
        NAME: 'blanchedalmond',
        COLOR: '#ffebcd'
    },
    {
        NAME: 'papayawhip',
        COLOR: '#ffefd5'
    },
    {
        NAME: 'lavenderblush',
        COLOR: '#fff0f5'
    },
    {
        NAME: 'seashell',
        COLOR: '#fff5ee'
    },
    {
        NAME: 'cornsilk',
        COLOR: '#fff8dc'
    },
    {
        NAME: 'lemonchiffon',
        COLOR: '#fffacd'
    },
    {
        NAME: 'floralwhite',
        COLOR: '#fffaf0'
    },
    {
        NAME: 'snow',
        COLOR: '#fffafa'
    },
    {
        NAME: 'yellow',
        COLOR: '#ffff00'
    },
    {
        NAME: 'lightyellow',
        COLOR: '#ffffe0'
    },
    {
        NAME: 'ivory',
        COLOR: '#fffff0'
    },
    {
        NAME: 'white',
        COLOR: '#ffffff'
    }
];

export const DEMO_TEMPLATE_DATA = [
    {
        id: 1,
        name: 'テンプレート1',
        staff_contacts: [
            {
                staff_code: '1',
                staff_name: 'Staff A1',
                staff_phone: '111-1111-1111'
            },
            {
                staff_code: '2',
                staff_name: 'Staff B1',
                staff_phone: '111-1111-1112'
            }
        ],
        major_classification: '1',
        middle_category: '1',
        minor_classification: '1',
        work_details: 'マラソン大会運営作業',
        license_qualification_work: 'License Qualification Work',
        clothes_specification: '2',
        other_clothing: '服装指定 テンプレート1',
        belongings: ['4'],
        belongings_text: '服装指定',
        supplementary_information: '無',
        files: [
            {
                filename: 'LinkLabel1',
                file: '1'
            },
            {
                filename: 'LinkLabel2',
                file: '2'
            },
            {
                filename: 'LinkLabel3',
                file: '3'
            },
            {
                filename: 'LinkLabel4',
                file: '4'
            },
            {
                filename: 'LinkLabel5',
                file: '5'
            }
        ]
    },
    {
        id: 2,
        name: 'テンプレート2',
        staff_contacts: [
            {
                staff_code: '3',
                staff_name: 'Staff A2',
                staff_phone: '222-2222-2221'
            },
            {
                staff_code: '4',
                staff_name: 'Staff B2',
                staff_phone: '222-2222-2222'
            }
        ],
        major_classification: '1',
        middle_category: '1',
        minor_classification: '1',
        work_details: 'マラソン大会運営作業',
        license_qualification_work: 'License Qualification Work',
        clothes_specification: '2',
        other_clothing: '服装指定 テンプレート2',
        belongings: ['4'],
        belongings_text: '',
        supplementary_information: '無',
        files: [
            {
                filename: 'LinkLabel1',
                file: '1'
            },
            {
                filename: 'LinkLabel2',
                file: '2'
            },
            {
                filename: 'LinkLabel3',
                file: '3'
            },
            {
                filename: 'LinkLabel4',
                file: '4'
            },
            {
                filename: 'LinkLabel5',
                file: '5'
            }
        ]
    },
    {
        id: 3,
        name: 'テンプレート3',
        staff_contacts: [
            {
                staff_code: '5',
                staff_name: 'Staff A3',
                staff_phone: '333-3333-3331'
            },
            {
                staff_code: '6',
                staff_name: 'Staff B3',
                staff_phone: '333-3333-3332'
            }
        ],
        major_classification: '1',
        middle_category: '1',
        minor_classification: '1',
        work_details: 'マラソン大会運営作業',
        license_qualification_work: 'License Qualification Work',
        clothes_specification: '2',
        other_clothing: '服装指定 テンプレート3',
        belongings: ['4'],
        belongings_text: '',
        supplementary_information: '無',
        files: [
            {
                filename: 'LinkLabel1',
                file: '1'
            },
            {
                filename: 'LinkLabel2',
                file: '2'
            },
            {
                filename: 'LinkLabel3',
                file: '3'
            },
            {
                filename: 'LinkLabel4',
                file: '4'
            },
            {
                filename: 'LinkLabel5',
                file: '5'
            }
        ]
    }
];

// CUS - 見積ステータス
export const CUS_STATUS_1 = {
    1: '下書き',
    2: '見積依頼中',
    3: '見積を確認する',
    4: '見積済'
};
// CUS - 依頼ステータス
export const CUS_STATUS_2 = {
    1: '新規申込中',
    2: '変更申込中',
    3: 'キャンセル申込中',
    4: '調整中',
    5: '新規受諾',
    6: '変更受諾',
    7: 'キャンセル受諾',
    8: 'キャンセル受諾(請求発生)',
    9: '御断りさせていただきます',
    10: '完了'
};

export const MAJOR_CLASSIFICATION = [
    {
        id: 1,
        content: 'イベント'
    },
    {
        id: 2,
        content: 'レンタル'
    },
    {
        id: 3,
        content: '建設'
    },
    {
        id: 4,
        content: '物流'
    },
    {
        id: 5,
        content: '販売'
    },
    {
        id: 6,
        content: 'SP'
    }
];
export const MEDIUM_CLASSIFICATION = [
    [
        {
            code: 1,
            name: '会場施工'
        },
        {
            code: 2,
            name: '運営'
        },
        {
            code: 3,
            name: '倉庫'
        },
        {
            code: 4,
            name: 'その他'
        }
    ],
    [
        {
            code: 1,
            name: '会場施工'
        },
        {
            code: 2,
            name: '備品搬入出'
        },
        {
            code: 3,
            name: '倉庫'
        },
        {
            code: 4,
            name: 'その他'
        }
    ],
    [
        {
            code: 1,
            name: '資材搬入搬出'
        },
        {
            code: 2,
            name: '雑工'
        },
        {
            code: 3,
            name: 'その他'
        }
    ],
    [
        {
            code: 1,
            name: '什器施工'
        },
        {
            code: 2,
            name: '事務所移転'
        },
        {
            code: 3,
            name: '搬入出'
        },
        {
            code: 4,
            name: '引越し'
        },
        {
            code: 5,
            name: '倉庫'
        },
        {
            code: 6,
            name: '配送助手'
        },
        {
            code: 7,
            name: 'デバンニング'
        },
        {
            code: 8,
            name: 'ピッキング'
        },
        {
            code: 9,
            name: 'その他'
        }
    ],
    [
        {
            code: 1,
            name: 'レジ'
        },
        {
            code: 2,
            name: 'サッカー'
        },
        {
            code: 3,
            name: '品出し'
        },
        {
            code: 4,
            name: 'その他'
        }
    ],
    [
        {
            code: 1,
            name: 'サンプリング'
        },
        {
            code: 2,
            name: '試食販売'
        },
        {
            code: 3,
            name: '販売促進'
        },
        {
            code: 4,
            name: 'その他'
        }
    ]
];
export const timeoutFocus = 100;
export const reloadPageTime = 5;
export const triggerTimeoutNotification = 5;
export const regexpValidateEmail = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
